// // File Location: src/pages/admin/HospitalApplicationDetails.jsx

// import React, { useState, useEffect } from 'react';
// import { useParams, useNavigate } from 'react-router-dom';
// import {
//   ArrowLeft,
//   Building,
//   MapPin,
//   Phone,
//   Mail,
//   Calendar,
//   User,
//   FileText,
//   Download,
//   Eye,
//   X,
//   CheckCircle,
//   XCircle,
//   AlertTriangle,
//   Loader,
//   Send,
//   MessageSquare,
//   Clock,
//   Shield,
//   Users,
//   Activity,
//   CreditCard,
//   Globe,
//   Building2,
//   Stethoscope,
//   Bed,
//   CheckSquare,
//   Star,
//   ExternalLink
// } from 'lucide-react';
// import { 
//   getHospitalApplication, 
//   approveHospitalApplication, 
//   rejectHospitalApplication,
//   requestAdditionalDocuments 
// } from '../../services/hospitalService';
// import { useAuth } from '../../context/AuthContext';

// const HospitalApplicationDetails = () => {
//   const { applicationId } = useParams();
//   const navigate = useNavigate();
//   const { userData } = useAuth();
  
//   const [application, setApplication] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [actionLoading, setActionLoading] = useState({});
//   const [showDocumentModal, setShowDocumentModal] = useState(false);
//   const [selectedDocument, setSelectedDocument] = useState(null);
//   const [showApprovalModal, setShowApprovalModal] = useState(false);
//   const [showRejectionModal, setShowRejectionModal] = useState(false);
//   const [showRequestModal, setShowRequestModal] = useState(false);
  
//   // Form states
//   const [approvalPassword, setApprovalPassword] = useState('');
//   const [rejectionReason, setRejectionReason] = useState('');
//   const [requestMessage, setRequestMessage] = useState('');
//   const [requestDocuments, setRequestDocuments] = useState([]);

//   // Available document types for requests
//   const availableDocuments = [
//     'Updated Registration Certificate',
//     'Latest NABH Certificate',
//     'Medical Establishment License',
//     'Fire Safety Certificate',
//     'Pollution Control Certificate',
//     'Additional Bank Documents',
//     'Updated Hospital Tariff',
//     'Staff Credentials',
//     'Equipment Certificate',
//     'Insurance Documents'
//   ];

//   useEffect(() => {
//     loadApplicationDetails();
//   }, [applicationId]);

//   const loadApplicationDetails = async () => {
//     setLoading(true);
//     try {
//       const result = await getHospitalApplication(applicationId);
//       if (result.success) {
//         setApplication(result.application);
//       } else {
//         console.error('Error loading application:', result.error);
//       }
//     } catch (error) {
//       console.error('Error loading application details:', error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleApproveHospital = async () => {
//     if (!approvalPassword.trim()) return;

//     setActionLoading(prev => ({ ...prev, approve: true }));
//     try {
//       const result = await approveHospitalApplication(
//         applicationId,
//         userData.uid,
//         approvalPassword
//       );

//       if (result.success) {
//         setApplication(prev => ({
//           ...prev,
//           status: 'approved',
//           approvedBy: userData.uid,
//           approvedAt: new Date()
//         }));
//         setShowApprovalModal(false);
//         setApprovalPassword('');
//         alert('Hospital approved successfully!');
//       } else {
//         alert('Error approving hospital: ' + result.error);
//       }
//     } catch (error) {
//       console.error('Error approving hospital:', error);
//       alert('Failed to approve hospital');
//     } finally {
//       setActionLoading(prev => ({ ...prev, approve: false }));
//     }
//   };

//   const handleRejectHospital = async () => {
//     if (!rejectionReason.trim()) return;

//     setActionLoading(prev => ({ ...prev, reject: true }));
//     try {
//       const result = await rejectHospitalApplication(
//         applicationId,
//         userData.uid,
//         rejectionReason
//       );

//       if (result.success) {
//         setApplication(prev => ({
//           ...prev,
//           status: 'rejected',
//           rejectedBy: userData.uid,
//           rejectedAt: new Date(),
//           rejectionReason
//         }));
//         setShowRejectionModal(false);
//         setRejectionReason('');
//         alert('Hospital application rejected.');
//       } else {
//         alert('Error rejecting hospital: ' + result.error);
//       }
//     } catch (error) {
//       console.error('Error rejecting hospital:', error);
//       alert('Failed to reject hospital');
//     } finally {
//       setActionLoading(prev => ({ ...prev, reject: false }));
//     }
//   };

//   const handleRequestAdditionalData = async () => {
//     if (!requestMessage.trim() || requestDocuments.length === 0) return;

//     setActionLoading(prev => ({ ...prev, request: true }));
//     try {
//       const result = await requestAdditionalDocuments(
//         applicationId,
//         userData.uid,
//         requestMessage,
//         requestDocuments
//       );

//       if (result.success) {
//         setShowRequestModal(false);
//         setRequestMessage('');
//         setRequestDocuments([]);
//         alert('Additional documents requested successfully!');
//         loadApplicationDetails(); // Refresh to show the request
//       } else {
//         alert('Error requesting documents: ' + result.error);
//       }
//     } catch (error) {
//       console.error('Error requesting documents:', error);
//       alert('Failed to request additional documents');
//     } finally {
//       setActionLoading(prev => ({ ...prev, request: false }));
//     }
//   };

//   const openDocument = (document) => {
//     setSelectedDocument(document);
//     setShowDocumentModal(true);
//   };

//   const downloadDocument = (document) => {
//     const link = document.createElement('a');
//     link.href = document.url;
//     link.download = document.fileName;
//     link.click();
//   };

//   const formatDate = (timestamp) => {
//     if (!timestamp) return 'N/A';
//     const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
//     return date.toLocaleDateString('en-IN', {
//       year: 'numeric',
//       month: 'long',
//       day: 'numeric',
//       hour: '2-digit',
//       minute: '2-digit'
//     });
//   };

//   const getStatusColor = (status) => {
//     switch (status) {
//       case 'pending':
//         return 'bg-yellow-100 text-yellow-800 border-yellow-200';
//       case 'approved':
//         return 'bg-green-100 text-green-800 border-green-200';
//       case 'rejected':
//         return 'bg-red-100 text-red-800 border-red-200';
//       default:
//         return 'bg-gray-100 text-gray-800 border-gray-200';
//     }
//   };

//   if (loading) {
//     return (
//       <div className="min-h-screen bg-gradient-to-br from-teal-50 via-cyan-50 to-blue-50 flex items-center justify-center">
//         <div className="text-center">
//           <Loader className="h-8 w-8 animate-spin text-teal-500 mx-auto mb-4" />
//           <p className="text-gray-600">Loading application details...</p>
//         </div>
//       </div>
//     );
//   }

//   if (!application) {
//     return (
//       <div className="min-h-screen bg-gradient-to-br from-teal-50 via-cyan-50 to-blue-50 flex items-center justify-center">
//         <div className="text-center">
//           <Building className="h-12 w-12 text-gray-400 mx-auto mb-4" />
//           <h3 className="text-lg font-medium text-gray-900 mb-2">Application Not Found</h3>
//           <p className="text-gray-600 mb-4">The requested hospital application could not be found.</p>
//           <button 
//             onClick={() => navigate('/admin/hospital-approvals')}
//             className="btn-primary"
//           >
//             <ArrowLeft className="h-4 w-4 mr-2" />
//             Back to Applications
//           </button>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="min-h-screen bg-gradient-to-br from-teal-50 via-cyan-50 to-blue-50">
//       {/* Header */}
//       <div className="bg-white shadow-sm border-b border-gray-200">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="flex items-center justify-between py-4">
//             <div className="flex items-center space-x-4">
//               <button
//                 onClick={() => navigate('/admin/dashboard')}
//                 className="btn-outline"
//               >
//                 <ArrowLeft className="h-4 w-4 mr-2" />
//                 Back to Dashboard
//               </button>
              
//               <div>
//                 <h1 className="text-2xl font-bold text-gray-900">Hospital Application Details</h1>
//                 <p className="text-sm text-gray-600">Application ID: {application.applicationId}</p>
//               </div>
//             </div>

//             <div className="flex items-center space-x-3">
//               <span className={`px-3 py-1 rounded-full text-sm font-medium border ${getStatusColor(application.status)}`}>
//                 {application.status.charAt(0).toUpperCase() + application.status.slice(1)}
//               </span>
              
//               {application.status === 'pending' && (
//                 <div className="flex items-center space-x-2">
//                   <button
//                     onClick={() => setShowRequestModal(true)}
//                     className="btn-outline"
//                   >
//                     <MessageSquare className="h-4 w-4 mr-2" />
//                     Request Data
//                   </button>
                  
//                   <button
//                     onClick={() => setShowRejectionModal(true)}
//                     className="btn-danger"
//                   >
//                     <XCircle className="h-4 w-4 mr-2" />
//                     Reject
//                   </button>
                  
//                   <button
//                     onClick={() => setShowApprovalModal(true)}
//                     className="btn-success"
//                   >
//                     <CheckCircle className="h-4 w-4 mr-2" />
//                     Approve
//                   </button>
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       </div>

//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
//         <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          
//           {/* Main Content */}
//           <div className="lg:col-span-2 space-y-6">
            
//             {/* Basic Information */}
//             <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
//               <div className="flex items-center space-x-3 mb-6">
//                 <div className="bg-teal-100 p-2 rounded-lg">
//                   <Building className="h-5 w-5 text-teal-600" />
//                 </div>
//                 <h2 className="text-xl font-semibold text-gray-900">Basic Information</h2>
//               </div>

//               <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//                 <div className="space-y-4">
//                   <div>
//                     <label className="text-sm font-medium text-gray-500">Hospital Name</label>
//                     <p className="text-lg font-semibold text-gray-900">{application.hospitalName}</p>
//                   </div>
                  
//                   <div>
//                     <label className="text-sm font-medium text-gray-500">Email Address</label>
//                     <div className="flex items-center space-x-2">
//                       <Mail className="h-4 w-4 text-gray-400" />
//                       <p className="text-gray-900">{application.email}</p>
//                     </div>
//                   </div>
                  
//                   <div>
//                     <label className="text-sm font-medium text-gray-500">Phone Number</label>
//                     <div className="flex items-center space-x-2">
//                       <Phone className="h-4 w-4 text-gray-400" />
//                       <p className="text-gray-900">{application.phone}</p>
//                     </div>
//                   </div>

//                   {application.website && (
//                     <div>
//                       <label className="text-sm font-medium text-gray-500">Website</label>
//                       <div className="flex items-center space-x-2">
//                         <Globe className="h-4 w-4 text-gray-400" />
//                         <a 
//                           href={application.website} 
//                           target="_blank" 
//                           rel="noopener noreferrer"
//                           className="text-teal-600 hover:text-teal-800"
//                         >
//                           {application.website}
//                           <ExternalLink className="h-3 w-3 ml-1 inline" />
//                         </a>
//                       </div>
//                     </div>
//                   )}
//                 </div>

//                 <div className="space-y-4">
//                   <div>
//                     <label className="text-sm font-medium text-gray-500">Address</label>
//                     <div className="flex items-start space-x-2">
//                       <MapPin className="h-4 w-4 text-gray-400 mt-1" />
//                       <div>
//                         <p className="text-gray-900">{application.address}</p>
//                         <p className="text-gray-600">{application.city}, {application.state}</p>
//                         <p className="text-gray-600">{application.pincode}</p>
//                       </div>
//                     </div>
//                   </div>
                  
//                   <div>
//                     <label className="text-sm font-medium text-gray-500">Application Submitted</label>
//                     <div className="flex items-center space-x-2">
//                       <Calendar className="h-4 w-4 text-gray-400" />
//                       <p className="text-gray-900">{formatDate(application.submittedAt)}</p>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* Hospital Details */}
//             <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
//               <div className="flex items-center space-x-3 mb-6">
//                 <div className="bg-blue-100 p-2 rounded-lg">
//                   <Building2 className="h-5 w-5 text-blue-600" />
//                 </div>
//                 <h2 className="text-xl font-semibold text-gray-900">Hospital Details</h2>
//               </div>

//               <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
//                 <div className="bg-gray-50 rounded-lg p-4">
//                   <div className="flex items-center space-x-2 mb-2">
//                     <Bed className="h-5 w-5 text-gray-600" />
//                     <span className="text-sm font-medium text-gray-500">Number of Beds</span>
//                   </div>
//                   <p className="text-2xl font-bold text-gray-900">{application.numberOfBeds}</p>
//                 </div>

//                 <div className="bg-gray-50 rounded-lg p-4">
//                   <div className="flex items-center space-x-2 mb-2">
//                     <Activity className="h-5 w-5 text-gray-600" />
//                     <span className="text-sm font-medium text-gray-500">Facilities</span>
//                   </div>
//                   <p className="text-2xl font-bold text-gray-900">{application.facilities?.length || 0}</p>
//                 </div>

//                 <div className="bg-gray-50 rounded-lg p-4">
//                   <div className="flex items-center space-x-2 mb-2">
//                     <Stethoscope className="h-5 w-5 text-gray-600" />
//                     <span className="text-sm font-medium text-gray-500">Specialities</span>
//                   </div>
//                   <p className="text-2xl font-bold text-gray-900">{application.specialities?.length || 0}</p>
//                 </div>
//               </div>

//               {/* Facilities */}
//               {application.facilities && application.facilities.length > 0 && (
//                 <div className="mt-6">
//                   <h3 className="text-lg font-medium text-gray-900 mb-3">Available Facilities</h3>
//                   <div className="grid grid-cols-2 md:grid-cols-3 gap-2">
//                     {application.facilities.map((facility, index) => (
//                       <div key={index} className="flex items-center space-x-2">
//                         <CheckSquare className="h-4 w-4 text-green-500" />
//                         <span className="text-sm text-gray-700">{facility}</span>
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//               )}

//               {/* Specialities */}
//               {application.specialities && application.specialities.length > 0 && (
//                 <div className="mt-6">
//                   <h3 className="text-lg font-medium text-gray-900 mb-3">Medical Specialities</h3>
//                   <div className="grid grid-cols-2 md:grid-cols-3 gap-2">
//                     {application.specialities.map((speciality, index) => (
//                       <div key={index} className="flex items-center space-x-2">
//                         <Star className="h-4 w-4 text-blue-500" />
//                         <span className="text-sm text-gray-700">{speciality}</span>
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//               )}
//             </div>

//             {/* Contact Information */}
//             <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
//               <div className="flex items-center space-x-3 mb-6">
//                 <div className="bg-purple-100 p-2 rounded-lg">
//                   <Users className="h-5 w-5 text-purple-600" />
//                 </div>
//                 <h2 className="text-xl font-semibold text-gray-900">Contact Information</h2>
//               </div>

//               <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//                 {/* Representative */}
//                 <div className="border border-gray-200 rounded-lg p-4">
//                   <h3 className="text-lg font-medium text-gray-900 mb-4">Hospital Representative</h3>
//                   <div className="space-y-3">
//                     <div>
//                       <label className="text-sm font-medium text-gray-500">Name</label>
//                       <p className="text-gray-900">{application.representative?.name}</p>
//                     </div>
//                     <div>
//                       <label className="text-sm font-medium text-gray-500">Designation</label>
//                       <p className="text-gray-900">{application.representative?.designation}</p>
//                     </div>
//                     <div>
//                       <label className="text-sm font-medium text-gray-500">Email</label>
//                       <p className="text-gray-900">{application.representative?.email}</p>
//                     </div>
//                     <div>
//                       <label className="text-sm font-medium text-gray-500">Phone</label>
//                       <p className="text-gray-900">{application.representative?.phone}</p>
//                     </div>
//                   </div>
//                 </div>

//                 {/* Managing Director */}
//                 <div className="border border-gray-200 rounded-lg p-4">
//                   <h3 className="text-lg font-medium text-gray-900 mb-4">Managing Director</h3>
//                   <div className="space-y-3">
//                     <div>
//                       <label className="text-sm font-medium text-gray-500">Name</label>
//                       <p className="text-gray-900">{application.managingDirector?.name}</p>
//                     </div>
//                     <div>
//                       <label className="text-sm font-medium text-gray-500">Contact</label>
//                       <p className="text-gray-900">{application.managingDirector?.contact}</p>
//                     </div>
//                     {application.managingDirector?.email && (
//                       <div>
//                         <label className="text-sm font-medium text-gray-500">Email</label>
//                         <p className="text-gray-900">{application.managingDirector.email}</p>
//                       </div>
//                     )}
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* Banking Details */}
//             {application.bankDetails && (
//               <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
//                 <div className="flex items-center space-x-3 mb-6">
//                   <div className="bg-green-100 p-2 rounded-lg">
//                     <CreditCard className="h-5 w-5 text-green-600" />
//                   </div>
//                   <h2 className="text-xl font-semibold text-gray-900">Banking Details</h2>
//                 </div>

//                 <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//                   <div>
//                     <label className="text-sm font-medium text-gray-500">Bank Name</label>
//                     <p className="text-gray-900">{application.bankDetails.bankName}</p>
//                   </div>
//                   <div>
//                     <label className="text-sm font-medium text-gray-500">Account Holder Name</label>
//                     <p className="text-gray-900">{application.bankDetails.accountHolderName}</p>
//                   </div>
//                   <div>
//                     <label className="text-sm font-medium text-gray-500">Account Number</label>
//                     <p className="text-gray-900 font-mono">****{application.bankDetails.accountNumber?.slice(-4)}</p>
//                   </div>
//                   <div>
//                     <label className="text-sm font-medium text-gray-500">IFSC Code</label>
//                     <p className="text-gray-900 font-mono">{application.bankDetails.ifscCode}</p>
//                   </div>
//                 </div>
//               </div>
//             )}

//             {/* Documents */}
//             <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
//               <div className="flex items-center space-x-3 mb-6">
//                 <div className="bg-orange-100 p-2 rounded-lg">
//                   <FileText className="h-5 w-5 text-orange-600" />
//                 </div>
//                 <h2 className="text-xl font-semibold text-gray-900">Uploaded Documents</h2>
//               </div>

//               {application.documents ? (
//                 <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                   {Object.entries(application.documents).map(([key, doc]) => (
//                     <div key={key} className="border border-gray-200 rounded-lg p-4">
//                       <div className="flex items-center justify-between mb-2">
//                         <h4 className="font-medium text-gray-900">{key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())}</h4>
//                         <div className="flex items-center space-x-2">
//                           <button
//                             onClick={() => openDocument(doc)}
//                             className="text-blue-600 hover:text-blue-800"
//                             title="View Document"
//                           >
//                             <Eye className="h-4 w-4" />
//                           </button>
//                           <button
//                             onClick={() => downloadDocument(doc)}
//                             className="text-green-600 hover:text-green-800"
//                             title="Download Document"
//                           >
//                             <Download className="h-4 w-4" />
//                           </button>
//                         </div>
//                       </div>
//                       <p className="text-sm text-gray-600">{doc.fileName}</p>
//                       <p className="text-xs text-gray-500">Size: {(doc.size / 1024).toFixed(1)} KB</p>
//                       <p className="text-xs text-gray-500">Uploaded: {formatDate(doc.uploadedAt)}</p>
//                     </div>
//                   ))}
//                 </div>
//               ) : (
//                 <p className="text-gray-500">No documents uploaded</p>
//               )}
//             </div>
//           </div>

//           {/* Sidebar */}
//           <div className="space-y-6">
            
//             {/* Application Status */}
//             <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
//               <h3 className="text-lg font-semibold text-gray-900 mb-4">Application Status</h3>
              
//               <div className="space-y-4">
//                 <div className="flex items-center justify-between">
//                   <span className="text-sm font-medium text-gray-500">Current Status</span>
//                   <span className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(application.status)}`}>
//                     {application.status.charAt(0).toUpperCase() + application.status.slice(1)}
//                   </span>
//                 </div>

//                 <div className="flex items-center justify-between">
//                   <span className="text-sm font-medium text-gray-500">Submitted On</span>
//                   <span className="text-sm text-gray-900">{formatDate(application.submittedAt)}</span>
//                 </div>

//                 {application.approvedAt && (
//                   <div className="flex items-center justify-between">
//                     <span className="text-sm font-medium text-gray-500">Approved On</span>
//                     <span className="text-sm text-gray-900">{formatDate(application.approvedAt)}</span>
//                   </div>
//                 )}

//                 {application.rejectedAt && (
//                   <div className="flex items-center justify-between">
//                     <span className="text-sm font-medium text-gray-500">Rejected On</span>
//                     <span className="text-sm text-gray-900">{formatDate(application.rejectedAt)}</span>
//                   </div>
//                 )}
//               </div>

//               {application.rejectionReason && (
//                 <div className="mt-4 p-3 bg-red-50 border border-red-200 rounded-lg">
//                   <h4 className="text-sm font-medium text-red-800 mb-1">Rejection Reason</h4>
//                   <p className="text-sm text-red-700">{application.rejectionReason}</p>
//                 </div>
//               )}
//             </div>

//             {/* Quick Actions */}
//             {application.status === 'pending' && (
//               <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
//                 <h3 className="text-lg font-semibold text-gray-900 mb-4">Quick Actions</h3>
                
//                 <div className="space-y-3">
//                   <button
//                     onClick={() => setShowRequestModal(true)}
//                     className="w-full btn-outline justify-start"
//                   >
//                     <MessageSquare className="h-4 w-4 mr-2" />
//                     Request Additional Data
//                   </button>
                  
//                   <button
//                     onClick={() => setShowRejectionModal(true)}
//                     className="w-full btn-danger justify-start"
//                   >
//                     <XCircle className="h-4 w-4 mr-2" />
//                     Reject Application
//                   </button>
                  
//                   <button
//                     onClick={() => setShowApprovalModal(true)}
//                     className="w-full btn-success justify-start"
//                   >
//                     <CheckCircle className="h-4 w-4 mr-2" />
//                     Approve Application
//                   </button>
//                 </div>
//               </div>
//             )}

//             {/* Activity Timeline */}
//             <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
//               <h3 className="text-lg font-semibold text-gray-900 mb-4">Activity Timeline</h3>
              
//               <div className="space-y-4">
//                 <div className="flex items-start space-x-3">
//                   <div className="bg-blue-100 p-1 rounded-full">
//                     <Clock className="h-3 w-3 text-blue-600" />
//                   </div>
//                   <div>
//                     <p className="text-sm font-medium text-gray-900">Application Submitted</p>
//                     <p className="text-xs text-gray-500">{formatDate(application.submittedAt)}</p>
//                   </div>
//                 </div>

//                 {application.status === 'approved' && (
//                   <div className="flex items-start space-x-3">
//                     <div className="bg-green-100 p-1 rounded-full">
//                       <CheckCircle className="h-3 w-3 text-green-600" />
//                     </div>
//                     <div>
//                       <p className="text-sm font-medium text-gray-900">Application Approved</p>
//                       <p className="text-xs text-gray-500">{formatDate(application.approvedAt)}</p>
//                     </div>
//                   </div>
//                 )}

//                 {application.status === 'rejected' && (
//                   <div className="flex items-start space-x-3">
//                     <div className="bg-red-100 p-1 rounded-full">
//                       <XCircle className="h-3 w-3 text-red-600" />
//                     </div>
//                     <div>
//                       <p className="text-sm font-medium text-gray-900">Application Rejected</p>
//                       <p className="text-xs text-gray-500">{formatDate(application.rejectedAt)}</p>
//                     </div>
//                   </div>
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Document Viewer Modal */}
//       {showDocumentModal && selectedDocument && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
//           <div className="bg-white rounded-lg max-w-4xl w-full h-5/6 flex flex-col">
//             <div className="flex items-center justify-between p-4 border-b border-gray-200">
//               <div>
//                 <h3 className="text-lg font-semibold text-gray-900">Document Viewer</h3>
//                 <p className="text-sm text-gray-600">{selectedDocument.fileName}</p>
//               </div>
//               <div className="flex items-center space-x-2">
//                 <button
//                   onClick={() => downloadDocument(selectedDocument)}
//                   className="btn-outline"
//                 >
//                   <Download className="h-4 w-4 mr-2" />
//                   Download
//                 </button>
//                 <button
//                   onClick={() => setShowDocumentModal(false)}
//                   className="text-gray-400 hover:text-gray-600"
//                 >
//                   <X className="h-6 w-6" />
//                 </button>
//               </div>
//             </div>
            
//             <div className="flex-1 p-4">
//               {selectedDocument.fileName.toLowerCase().endsWith('.pdf') ? (
//                 <iframe
//                   src={selectedDocument.url}
//                   className="w-full h-full border border-gray-300 rounded"
//                   title="Document Viewer"
//                 />
//               ) : (
//                 <div className="w-full h-full flex items-center justify-center bg-gray-50 rounded">
//                   <img
//                     src={selectedDocument.url}
//                     alt={selectedDocument.fileName}
//                     className="max-w-full max-h-full object-contain"
//                   />
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Approval Modal */}
//       {showApprovalModal && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
//           <div className="bg-white rounded-lg max-w-md w-full p-6">
//             <div className="flex items-center justify-between mb-4">
//               <h3 className="text-lg font-semibold text-gray-900">Approve Hospital Application</h3>
//               <button
//                 onClick={() => setShowApprovalModal(false)}
//                 className="text-gray-400 hover:text-gray-600"
//               >
//                 <X className="h-6 w-6" />
//               </button>
//             </div>

//             <div className="mb-6">
//               <div className="bg-green-50 border border-green-200 rounded-lg p-4 mb-4">
//                 <div className="flex items-center space-x-3">
//                   <CheckCircle className="h-5 w-5 text-green-600" />
//                   <div>
//                     <h4 className="font-medium text-green-800">Approving Hospital</h4>
//                     <p className="text-sm text-green-600">
//                       {application.hospitalName} will be granted access to the platform
//                     </p>
//                   </div>
//                 </div>
//               </div>

//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-2">
//                   Account Password *
//                 </label>
//                 <input
//                   type="password"
//                   value={approvalPassword}
//                   onChange={(e) => setApprovalPassword(e.target.value)}
//                   className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-teal-500"
//                   placeholder="Enter password for hospital account"
//                   required
//                 />
//                 <p className="text-xs text-gray-500 mt-1">
//                   This password will be sent to the hospital for account access
//                 </p>
//               </div>
//             </div>

//             <div className="flex justify-end space-x-3">
//               <button
//                 onClick={() => setShowApprovalModal(false)}
//                 className="btn-outline"
//               >
//                 Cancel
//               </button>
//               <button
//                 onClick={handleApproveHospital}
//                 disabled={!approvalPassword.trim() || actionLoading.approve}
//                 className="btn-success"
//               >
//                 {actionLoading.approve ? (
//                   <>
//                     <Loader className="h-4 w-4 mr-2 animate-spin" />
//                     Approving...
//                   </>
//                 ) : (
//                   <>
//                     <CheckCircle className="h-4 w-4 mr-2" />
//                     Approve Hospital
//                   </>
//                 )}
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Rejection Modal */}
//       {showRejectionModal && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
//           <div className="bg-white rounded-lg max-w-md w-full p-6">
//             <div className="flex items-center justify-between mb-4">
//               <h3 className="text-lg font-semibold text-gray-900">Reject Hospital Application</h3>
//               <button
//                 onClick={() => setShowRejectionModal(false)}
//                 className="text-gray-400 hover:text-gray-600"
//               >
//                 <X className="h-6 w-6" />
//               </button>
//             </div>

//             <div className="mb-6">
//               <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-4">
//                 <div className="flex items-center space-x-3">
//                   <XCircle className="h-5 w-5 text-red-600" />
//                   <div>
//                     <h4 className="font-medium text-red-800">Rejecting Application</h4>
//                     <p className="text-sm text-red-600">
//                       {application.hospitalName} will be notified about the rejection
//                     </p>
//                   </div>
//                 </div>
//               </div>

//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-2">
//                   Rejection Reason *
//                 </label>
//                 <textarea
//                   value={rejectionReason}
//                   onChange={(e) => setRejectionReason(e.target.value)}
//                   rows="4"
//                   className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-teal-500"
//                   placeholder="Provide detailed reason for rejection..."
//                   required
//                 />
//                 <p className="text-xs text-gray-500 mt-1">
//                   This reason will be communicated to the hospital
//                 </p>
//               </div>
//             </div>

//             <div className="flex justify-end space-x-3">
//               <button
//                 onClick={() => setShowRejectionModal(false)}
//                 className="btn-outline"
//               >
//                 Cancel
//               </button>
//               <button
//                 onClick={handleRejectHospital}
//                 disabled={!rejectionReason.trim() || actionLoading.reject}
//                 className="btn-danger"
//               >
//                 {actionLoading.reject ? (
//                   <>
//                     <Loader className="h-4 w-4 mr-2 animate-spin" />
//                     Rejecting...
//                   </>
//                 ) : (
//                   <>
//                     <XCircle className="h-4 w-4 mr-2" />
//                     Reject Application
//                   </>
//                 )}
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Request Additional Data Modal */}
//       {showRequestModal && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
//           <div className="bg-white rounded-lg max-w-lg w-full p-6">
//             <div className="flex items-center justify-between mb-4">
//               <h3 className="text-lg font-semibold text-gray-900">Request Additional Documents</h3>
//               <button
//                 onClick={() => setShowRequestModal(false)}
//                 className="text-gray-400 hover:text-gray-600"
//               >
//                 <X className="h-6 w-6" />
//               </button>
//             </div>

//             <div className="mb-6">
//               <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-4">
//                 <div className="flex items-center space-x-3">
//                   <MessageSquare className="h-5 w-5 text-blue-600" />
//                   <div>
//                     <h4 className="font-medium text-blue-800">Request from Hospital</h4>
//                     <p className="text-sm text-blue-600">
//                       {application.hospitalName} will be notified to submit additional documents
//                     </p>
//                   </div>
//                 </div>
//               </div>

//               <div className="mb-4">
//                 <label className="block text-sm font-medium text-gray-700 mb-2">
//                   Request Message *
//                 </label>
//                 <textarea
//                   value={requestMessage}
//                   onChange={(e) => setRequestMessage(e.target.value)}
//                   rows="3"
//                   className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-teal-500"
//                   placeholder="Explain what additional information or documents are needed..."
//                   required
//                 />
//               </div>

//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-2">
//                   Required Documents *
//                 </label>
//                 <div className="space-y-2 max-h-40 overflow-y-auto border border-gray-200 rounded-lg p-3">
//                   {availableDocuments.map((doc, index) => (
//                     <label key={index} className="flex items-center space-x-2">
//                       <input
//                         type="checkbox"
//                         checked={requestDocuments.includes(doc)}
//                         onChange={(e) => {
//                           if (e.target.checked) {
//                             setRequestDocuments([...requestDocuments, doc]);
//                           } else {
//                             setRequestDocuments(requestDocuments.filter(d => d !== doc));
//                           }
//                         }}
//                         className="rounded border-gray-300 text-teal-600 focus:ring-teal-500"
//                       />
//                       <span className="text-sm text-gray-700">{doc}</span>
//                     </label>
//                   ))}
//                 </div>
//                 <p className="text-xs text-gray-500 mt-1">
//                   Select the documents that need to be submitted
//                 </p>
//               </div>
//             </div>

//             <div className="flex justify-end space-x-3">
//               <button
//                 onClick={() => setShowRequestModal(false)}
//                 className="btn-outline"
//               >
//                 Cancel
//               </button>
//               <button
//                 onClick={handleRequestAdditionalData}
//                 disabled={!requestMessage.trim() || requestDocuments.length === 0 || actionLoading.request}
//                 className="btn-primary"
//               >
//                 {actionLoading.request ? (
//                   <>
//                     <Loader className="h-4 w-4 mr-2 animate-spin" />
//                     Sending Request...
//                   </>
//                 ) : (
//                   <>
//                     <Send className="h-4 w-4 mr-2" />
//                     Send Request
//                   </>
//                 )}
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default HospitalApplicationDetails;







// File Location: src/pages/admin/HospitalApplicationDetails.jsx

import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useBackToDashboard } from '../../utils/navigationUtils';
import {
  ArrowLeft,
  Building,
  MapPin,
  Phone,
  Mail,
  Calendar,
  User,
  FileText,
  Download,
  Eye,
  X,
  CheckCircle,
  XCircle,
  AlertTriangle,
  Loader,
  Send,
  MessageSquare,
  Clock,
  Shield,
  Users,
  Activity,
  CreditCard,
  Globe,
  Building2,
  Stethoscope,
  Bed,
  CheckSquare,
  Star,
  ExternalLink,
  Pencil,
  Camera,
  Award,
  BriefcaseMedical
} from 'lucide-react';
import { 
  getHospitalApplication, 
  approveHospitalApplication, 
  rejectHospitalApplication,
  requestAdditionalDocuments 
} from '../../services/hospitalService';
import { useAuth } from '../../context/AuthContext';

const HospitalApplicationDetails = () => {
  const { applicationId } = useParams();
  const navigate = useNavigate();
  const { userData } = useAuth();
  const goBackToDashboard = useBackToDashboard();
  
  const [application, setApplication] = useState(null);
  const [loading, setLoading] = useState(true);
  const [actionLoading, setActionLoading] = useState({});
  const [showDocumentModal, setShowDocumentModal] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [showApprovalModal, setShowApprovalModal] = useState(false);
  const [showRejectionModal, setShowRejectionModal] = useState(false);
  const [showRequestModal, setShowRequestModal] = useState(false);
  
  // Form states
  const [rejectionReason, setRejectionReason] = useState('');
  const [requestMessage, setRequestMessage] = useState('');
  const [requestDocuments, setRequestDocuments] = useState([]);

  // Available document types for requests
  const availableDocuments = [
    'Updated Registration Certificate',
    'Latest NABH Certificate',
    'Quality Council of India Certificate',
    'Medical Establishment License',
    'Pharmacy Certificate',
    'Fire Safety Certificate',
    'Pollution Control Certificate',
    'Additional Bank Documents',
    'Updated Hospital Tariff',
    'Staff Credentials',
    'Equipment Certificate',
    'Insurance Documents',
    'Additional Facility Photos'
  ];

  useEffect(() => {
    loadApplicationDetails();
  }, [applicationId]);

  const loadApplicationDetails = async () => {
    setLoading(true);
    try {
      const result = await getHospitalApplication(applicationId);
      if (result.success) {
        setApplication(result.application);
      } else {
        console.error('Error loading application:', result.error);
      }
    } catch (error) {
      console.error('Error loading application details:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleApproveHospital = async () => {
    setActionLoading(prev => ({ ...prev, approve: true }));
    try {
      const result = await approveHospitalApplication(
        applicationId,
        userData.uid
      );

      if (result.success) {
        setApplication(prev => ({
          ...prev,
          status: 'approved',
          approvedBy: userData.uid,
          approvedAt: new Date()
        }));
        setShowApprovalModal(false);
        alert('Hospital approved successfully!');
      } else {
        alert('Error approving hospital: ' + result.error);
      }
    } catch (error) {
      console.error('Error approving hospital:', error);
      alert('Failed to approve hospital');
    } finally {
      setActionLoading(prev => ({ ...prev, approve: false }));
    }
  };

  const handleRejectHospital = async () => {
    if (!rejectionReason.trim()) return;

    setActionLoading(prev => ({ ...prev, reject: true }));
    try {
      const result = await rejectHospitalApplication(
        applicationId,
        userData.uid,
        rejectionReason
      );

      if (result.success) {
        setApplication(prev => ({
          ...prev,
          status: 'rejected',
          rejectedBy: userData.uid,
          rejectedAt: new Date(),
          rejectionReason
        }));
        setShowRejectionModal(false);
        setRejectionReason('');
        alert('Hospital application rejected.');
      } else {
        alert('Error rejecting hospital: ' + result.error);
      }
    } catch (error) {
      console.error('Error rejecting hospital:', error);
      alert('Failed to reject hospital');
    } finally {
      setActionLoading(prev => ({ ...prev, reject: false }));
    }
  };

  const handleRequestAdditionalData = async () => {
    if (!requestMessage.trim() || requestDocuments.length === 0) return;

    setActionLoading(prev => ({ ...prev, request: true }));
    try {
      const result = await requestAdditionalDocuments(
        applicationId,
        userData.uid,
        requestMessage,
        requestDocuments
      );

      if (result.success) {
        setShowRequestModal(false);
        setRequestMessage('');
        setRequestDocuments([]);
        alert('Additional documents requested successfully!');
        loadApplicationDetails(); // Refresh to show the request
      } else {
        alert('Error requesting documents: ' + result.error);
      }
    } catch (error) {
      console.error('Error requesting documents:', error);
      alert('Failed to request additional documents');
    } finally {
      setActionLoading(prev => ({ ...prev, request: false }));
    }
  };

  const openDocument = (document) => {
    setSelectedDocument(document);
    setShowDocumentModal(true);
  };

  const downloadDocument = (document) => {
    const link = document.createElement('a');
    link.href = document.url;
    link.download = document.fileName;
    link.click();
  };

  const formatDate = (timestamp) => {
    if (!timestamp) return 'N/A';
    const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
    return date.toLocaleDateString('en-IN', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'pending':
        return 'bg-yellow-100 text-yellow-800 border-yellow-200';
      case 'approved':
        return 'bg-green-100 text-green-800 border-green-200';
      case 'rejected':
        return 'bg-red-100 text-red-800 border-red-200';
      default:
        return 'bg-gray-100 text-gray-800 border-gray-200';
    }
  };

  // Helper function to get facility photos
  const getFacilityPhotos = () => {
    if (!application.documents) return [];
    return Object.entries(application.documents)
      .filter(([key]) => key.startsWith('facilitiesPhoto_'))
      .map(([key, doc]) => ({ key, ...doc }));
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-teal-50 via-cyan-50 to-blue-50 flex items-center justify-center">
        <div className="text-center">
          <Loader className="h-8 w-8 animate-spin text-teal-500 mx-auto mb-4" />
          <p className="text-gray-600">Loading application details...</p>
        </div>
      </div>
    );
  }

  if (!application) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-teal-50 via-cyan-50 to-blue-50 flex items-center justify-center">
        <div className="text-center">
          <Building className="h-12 w-12 text-gray-400 mx-auto mb-4" />
          <h3 className="text-lg font-medium text-gray-900 mb-2">Application Not Found</h3>
          <p className="text-gray-600 mb-4">The requested hospital application could not be found.</p>
          <button 
            onClick={() => navigate('/admin/hospital-approvals')}
            className="btn-primary"
          >
            <ArrowLeft className="h-4 w-4 mr-2" />
            Back to Applications
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-teal-50 via-cyan-50 to-blue-50">
      {/* Header */}
      <div className="bg-white shadow-sm border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between py-4">
            <div className="flex items-center space-x-4">
              <button
                onClick={() => goBackToDashboard(navigate)}
                className="btn-outline"
              >
                <ArrowLeft className="h-4 w-4 mr-2" />
                Back to Dashboard
              </button>
              
              <div>
                <h1 className="text-2xl font-bold text-gray-900">Hospital Application Details</h1>
                <p className="text-sm text-gray-600">Application ID: {application.applicationId}</p>
              </div>
            </div>

            <div className="flex items-center space-x-3">
              <span className={`px-3 py-1 rounded-full text-sm font-medium border ${getStatusColor(application.status)}`}>
                {application.status.charAt(0).toUpperCase() + application.status.slice(1)}
              </span>
              <button
                onClick={() => navigate(`/admin/hospital-edit/${application.applicationId}`)}
                className="btn-outline"
              >
                <Pencil className="h-4 w-4 mr-2" />
                Edit
              </button>
              
              {application.status === 'pending' && (
                <div className="flex items-center space-x-2">
                  <button
                    onClick={() => setShowRequestModal(true)}
                    className="btn-outline"
                  >
                    <MessageSquare className="h-4 w-4 mr-2" />
                    Request Data
                  </button>
                  
                  <button
                    onClick={() => setShowRejectionModal(true)}
                    className="btn-danger"
                  >
                    <XCircle className="h-4 w-4 mr-2" />
                    Reject
                  </button>
                  
                  <button
                    onClick={() => setShowApprovalModal(true)}
                    className="btn-success"
                  >
                    <CheckCircle className="h-4 w-4 mr-2" />
                    Approve
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          
          {/* Main Content */}
          <div className="lg:col-span-2 space-y-6">
            
            {/* Basic Information */}
            <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
              <div className="flex items-center space-x-3 mb-6">
                <div className="bg-teal-100 p-2 rounded-lg">
                  <Building className="h-5 w-5 text-teal-600" />
                </div>
                <h2 className="text-xl font-semibold text-gray-900">Basic Information</h2>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="space-y-4">
                  <div>
                    <label className="text-sm font-medium text-gray-500">Hospital Name</label>
                    <p className="text-lg font-semibold text-gray-900">{application.hospitalName}</p>
                  </div>
                  
                  <div>
                    <label className="text-sm font-medium text-gray-500">Registration Number</label>
                    <p className="text-gray-900 font-mono">{application.registrationNumber}</p>
                  </div>

                  <div>
                    <label className="text-sm font-medium text-gray-500">Registration Validity</label>
                    <div className="flex items-center space-x-2">
                      <Calendar className="h-4 w-4 text-gray-400" />
                      <p className="text-gray-900">{application.registrationValidityDate}</p>
                    </div>
                  </div>
                  
                  <div>
                    <label className="text-sm font-medium text-gray-500">Email Address</label>
                    <div className="flex items-center space-x-2">
                      <Mail className="h-4 w-4 text-gray-400" />
                      <p className="text-gray-900">{application.email}</p>
                    </div>
                  </div>
                  
                  <div>
                    <label className="text-sm font-medium text-gray-500">Phone Number</label>
                    <div className="flex items-center space-x-2">
                      <Phone className="h-4 w-4 text-gray-400" />
                      <p className="text-gray-900">{application.phone}</p>
                    </div>
                  </div>

                  {application.website && (
                    <div>
                      <label className="text-sm font-medium text-gray-500">Website</label>
                      <div className="flex items-center space-x-2">
                        <Globe className="h-4 w-4 text-gray-400" />
                        <a 
                          href={application.website} 
                          target="_blank" 
                          rel="noopener noreferrer"
                          className="text-teal-600 hover:text-teal-800"
                        >
                          {application.website}
                          <ExternalLink className="h-3 w-3 ml-1 inline" />
                        </a>
                      </div>
                    </div>
                  )}
                </div>

                <div className="space-y-4">
                  <div>
                    <label className="text-sm font-medium text-gray-500">Address</label>
                    <div className="flex items-start space-x-2">
                      <MapPin className="h-4 w-4 text-gray-400 mt-1" />
                      <div>
                        <p className="text-gray-900">{application.address}</p>
                        <p className="text-gray-600">{application.city}, {application.state}</p>
                        <p className="text-gray-600">{application.pincode}</p>
                      </div>
                    </div>
                  </div>
                  
                  <div>
                    <label className="text-sm font-medium text-gray-500">Application Submitted</label>
                    <div className="flex items-center space-x-2">
                      <Calendar className="h-4 w-4 text-gray-400" />
                      <p className="text-gray-900">{formatDate(application.submittedAt)}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Hospital Details */}
            <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
              <div className="flex items-center space-x-3 mb-6">
                <div className="bg-blue-100 p-2 rounded-lg">
                  <Building2 className="h-5 w-5 text-blue-600" />
                </div>
                <h2 className="text-xl font-semibold text-gray-900">Hospital Details</h2>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
                <div className="bg-gray-50 rounded-lg p-4">
                  <div className="flex items-center space-x-2 mb-2">
                    <Bed className="h-5 w-5 text-gray-600" />
                    <span className="text-sm font-medium text-gray-500">Number of Beds</span>
                  </div>
                  <p className="text-2xl font-bold text-gray-900">{application.numberOfBeds}</p>
                </div>

                <div className="bg-gray-50 rounded-lg p-4">
                  <div className="flex items-center space-x-2 mb-2">
                    <Activity className="h-5 w-5 text-gray-600" />
                    <span className="text-sm font-medium text-gray-500">Facilities</span>
                  </div>
                  <p className="text-2xl font-bold text-gray-900">{application.facilities?.length || 0}</p>
                </div>

                <div className="bg-gray-50 rounded-lg p-4">
                  <div className="flex items-center space-x-2 mb-2">
                    <Stethoscope className="h-5 w-5 text-gray-600" />
                    <span className="text-sm font-medium text-gray-500">Specialities</span>
                  </div>
                  <p className="text-2xl font-bold text-gray-900">{application.specialities?.length || 0}</p>
                </div>
              </div>

              {/* Pharmacy Information */}
              {application.pharmacyType && (
                <div className="mb-6">
                  <h3 className="text-lg font-medium text-gray-900 mb-3 flex items-center">
                    <BriefcaseMedical className="h-5 w-5 mr-2 text-purple-600" />
                    Pharmacy Information
                  </h3>
                  <div className="bg-purple-50 rounded-lg p-4 border border-purple-200">
                    <div className="flex items-center justify-between">
                      <div>
                        <span className="text-sm font-medium text-purple-700">Pharmacy Type:</span>
                        <span className={`ml-2 px-2 py-1 text-xs font-semibold rounded-full ${
                          application.pharmacyType === 'inhouse' 
                            ? 'bg-green-100 text-green-800' 
                            : 'bg-blue-100 text-blue-800'
                        }`}>
                          {application.pharmacyType === 'inhouse' ? 'In-house' : 'Outsourced'}
                        </span>
                      </div>
                      {application.pharmacyType === 'inhouse' && application.dlNumber && (
                        <div>
                          <span className="text-sm font-medium text-purple-700">DL Number:</span>
                          <span className="ml-2 font-mono text-purple-900">{application.dlNumber}</span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}

              {/* Quality Certifications */}
              {(application.hasNABH || application.hasQualityCouncil) && (
                <div className="mb-6">
                  <h3 className="text-lg font-medium text-gray-900 mb-3 flex items-center">
                    <Award className="h-5 w-5 mr-2 text-green-600" />
                    Quality Certifications
                  </h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {application.hasNABH && (
                      <div className="bg-green-50 rounded-lg p-4 border border-green-200">
                        <div className="flex items-center space-x-3">
                          <CheckCircle className="h-5 w-5 text-green-600" />
                          <span className="font-medium text-green-800">NABH Certified</span>
                        </div>
                      </div>
                    )}
                    {application.hasQualityCouncil && (
                      <div className="bg-blue-50 rounded-lg p-4 border border-blue-200">
                        <div className="flex items-center space-x-3">
                          <CheckCircle className="h-5 w-5 text-blue-600" />
                          <span className="font-medium text-blue-800">Quality Council of India Certified</span>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              )}

              {/* Facilities */}
              {application.facilities && application.facilities.length > 0 && (
                <div className="mb-6">
                  <h3 className="text-lg font-medium text-gray-900 mb-3">Available Facilities</h3>
                  <div className="grid grid-cols-2 md:grid-cols-3 gap-2">
                    {application.facilities.map((facility, index) => (
                      <div key={index} className="flex items-center space-x-2">
                        <CheckSquare className="h-4 w-4 text-green-500" />
                        <span className="text-sm text-gray-700">{facility}</span>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Specialities */}
              {application.specialities && application.specialities.length > 0 && (
                <div>
                  <h3 className="text-lg font-medium text-gray-900 mb-3">Medical Specialities</h3>
                  <div className="grid grid-cols-2 md:grid-cols-3 gap-2">
                    {application.specialities.map((speciality, index) => (
                      <div key={index} className="flex items-center space-x-2">
                        <Star className="h-4 w-4 text-blue-500" />
                        <span className="text-sm text-gray-700">{speciality}</span>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>

            {/* Contact Information */}
            <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
              <div className="flex items-center space-x-3 mb-6">
                <div className="bg-purple-100 p-2 rounded-lg">
                  <Users className="h-5 w-5 text-purple-600" />
                </div>
                <h2 className="text-xl font-semibold text-gray-900">Contact Information</h2>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Managing Director */}
                <div className="border border-gray-200 rounded-lg p-4">
                  <h3 className="text-lg font-medium text-gray-900 mb-4">Managing Director</h3>
                  <div className="space-y-3">
                    <div>
                      <label className="text-sm font-medium text-gray-500">Name</label>
                      <p className="text-gray-900">{application.managingDirector?.name}</p>
                    </div>
                    <div>
                      <label className="text-sm font-medium text-gray-500">Contact</label>
                      <p className="text-gray-900">{application.managingDirector?.contact}</p>
                    </div>
                    {application.managingDirector?.email && (
                      <div>
                        <label className="text-sm font-medium text-gray-500">Email</label>
                        <p className="text-gray-900">{application.managingDirector.email}</p>
                      </div>
                    )}
                  </div>
                </div>

                {/* Representative */}
                <div className="border border-gray-200 rounded-lg p-4">
                  <h3 className="text-lg font-medium text-gray-900 mb-4">Hospital Representative</h3>
                  <div className="space-y-3">
                    <div>
                      <label className="text-sm font-medium text-gray-500">Name</label>
                      <p className="text-gray-900">{application.representative?.name}</p>
                    </div>
                    <div>
                      <label className="text-sm font-medium text-gray-500">Designation</label>
                      <p className="text-gray-900">{application.representative?.designation}</p>
                    </div>
                    <div>
                      <label className="text-sm font-medium text-gray-500">Email</label>
                      <p className="text-gray-900">{application.representative?.email}</p>
                    </div>
                    <div>
                      <label className="text-sm font-medium text-gray-500">Phone</label>
                      <p className="text-gray-900">{application.representative?.phone}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Banking Details */}
            {application.bankDetails && (
              <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
                <div className="flex items-center space-x-3 mb-6">
                  <div className="bg-green-100 p-2 rounded-lg">
                    <CreditCard className="h-5 w-5 text-green-600" />
                  </div>
                  <h2 className="text-xl font-semibold text-gray-900">Banking Details</h2>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label className="text-sm font-medium text-gray-500">Bank Name</label>
                    <p className="text-gray-900">{application.bankDetails.bankName}</p>
                  </div>
                  <div>
                    <label className="text-sm font-medium text-gray-500">Account Holder Name</label>
                    <p className="text-gray-900">{application.bankDetails.accountHolderName}</p>
                  </div>
                  <div>
                    <label className="text-sm font-medium text-gray-500">Account Number</label>
                    <p className="text-gray-900 font-mono">****{application.bankDetails.accountNumber?.slice(-4)}</p>
                  </div>
                  <div>
                    <label className="text-sm font-medium text-gray-500">IFSC Code</label>
                    <p className="text-gray-900 font-mono">{application.bankDetails.ifscCode}</p>
                  </div>
                </div>
              </div>
            )}

            {/* Documents */}
            <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
              <div className="flex items-center space-x-3 mb-6">
                <div className="bg-orange-100 p-2 rounded-lg">
                  <FileText className="h-5 w-5 text-orange-600" />
                </div>
                <h2 className="text-xl font-semibold text-gray-900">Uploaded Documents</h2>
              </div>

              {application.documents ? (
                <div className="space-y-6">
                  {/* Facility Photos Section */}
                  {getFacilityPhotos().length > 0 && (
                    <div>
                      <h3 className="text-lg font-medium text-gray-900 mb-3 flex items-center">
                        <Camera className="h-5 w-5 mr-2 text-blue-600" />
                        Facility Photos ({getFacilityPhotos().length} photos)
                      </h3>
                      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                        {getFacilityPhotos().map((photo, index) => (
                          <div key={photo.key} className="relative group">
                            <div className="aspect-square bg-gray-100 rounded-lg overflow-hidden">
                              <img
                                src={photo.url}
                                alt={`Facility ${index + 1}`}
                                className="w-full h-full object-cover"
                              />
                              <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-30 transition-opacity flex items-center justify-center">
                                <div className="opacity-0 group-hover:opacity-100 transition-opacity flex space-x-2">
                                  <button
                                    onClick={() => openDocument(photo)}
                                    className="bg-white text-gray-800 p-2 rounded-full hover:bg-gray-100"
                                    title="View Photo"
                                  >
                                    <Eye className="h-4 w-4" />
                                  </button>
                                  <button
                                    onClick={() => downloadDocument(photo)}
                                    className="bg-white text-gray-800 p-2 rounded-full hover:bg-gray-100"
                                    title="Download Photo"
                                  >
                                    <Download className="h-4 w-4" />
                                  </button>
                                </div>
                              </div>
                            </div>
                            <p className="text-xs text-gray-500 mt-1 truncate">{photo.fileName}</p>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* Other Documents */}
                  <div>
                    <h3 className="text-lg font-medium text-gray-900 mb-3">Other Documents</h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      {Object.entries(application.documents)
                        .filter(([key]) => !key.startsWith('facilitiesPhoto_'))
                        .map(([key, doc]) => (
                        <div key={key} className="border border-gray-200 rounded-lg p-4">
                          <div className="flex items-center justify-between mb-2">
                            <h4 className="font-medium text-gray-900">{key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())}</h4>
                            <div className="flex items-center space-x-2">
                              <button
                                onClick={() => openDocument(doc)}
                                className="text-blue-600 hover:text-blue-800"
                                title="View Document"
                              >
                                <Eye className="h-4 w-4" />
                              </button>
                              <button
                                onClick={() => downloadDocument(doc)}
                                className="text-green-600 hover:text-green-800"
                                title="Download Document"
                              >
                                <Download className="h-4 w-4" />
                              </button>
                            </div>
                          </div>
                          <p className="text-sm text-gray-600">{doc.fileName}</p>
                          <p className="text-xs text-gray-500">Size: {(doc.size / 1024).toFixed(1)} KB</p>
                          <p className="text-xs text-gray-500">Uploaded: {formatDate(doc.uploadedAt)}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              ) : (
                <p className="text-gray-500">No documents uploaded</p>
              )}
            </div>
          </div>

          {/* Sidebar */}
          <div className="space-y-6">
            
            {/* Application Status */}
            <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
              <h3 className="text-lg font-semibold text-gray-900 mb-4">Application Status</h3>
              
              <div className="space-y-4">
                <div className="flex items-center justify-between">
                  <span className="text-sm font-medium text-gray-500">Current Status</span>
                  <span className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(application.status)}`}>
                    {application.status.charAt(0).toUpperCase() + application.status.slice(1)}
                  </span>
                </div>

                <div className="flex items-center justify-between">
                  <span className="text-sm font-medium text-gray-500">Submitted On</span>
                  <span className="text-sm text-gray-900">{formatDate(application.submittedAt)}</span>
                </div>

                {application.approvedAt && (
                  <div className="flex items-center justify-between">
                    <span className="text-sm font-medium text-gray-500">Approved On</span>
                    <span className="text-sm text-gray-900">{formatDate(application.approvedAt)}</span>
                  </div>
                )}

                {application.rejectedAt && (
                  <div className="flex items-center justify-between">
                    <span className="text-sm font-medium text-gray-500">Rejected On</span>
                    <span className="text-sm text-gray-900">{formatDate(application.rejectedAt)}</span>
                  </div>
                )}
              </div>

              {application.rejectionReason && (
                <div className="mt-4 p-3 bg-red-50 border border-red-200 rounded-lg">
                  <h4 className="text-sm font-medium text-red-800 mb-1">Rejection Reason</h4>
                  <p className="text-sm text-red-700">{application.rejectionReason}</p>
                </div>
              )}
            </div>

            {/* Quick Actions */}
            {application.status === 'pending' && (
              <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
                <h3 className="text-lg font-semibold text-gray-900 mb-4">Quick Actions</h3>
                
                <div className="space-y-3">
                  <button
                    onClick={() => setShowRequestModal(true)}
                    className="w-full btn-outline justify-start"
                  >
                    <MessageSquare className="h-4 w-4 mr-2" />
                    Request Additional Data
                  </button>
                  
                  <button
                    onClick={() => setShowRejectionModal(true)}
                    className="w-full btn-danger justify-start"
                  >
                    <XCircle className="h-4 w-4 mr-2" />
                    Reject Application
                  </button>
                  
                  <button
                    onClick={() => setShowApprovalModal(true)}
                    className="w-full btn-success justify-start"
                  >
                    <CheckCircle className="h-4 w-4 mr-2" />
                    Approve Application
                  </button>
                </div>
              </div>
            )}

            {/* Hospital Statistics */}
            <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
              <h3 className="text-lg font-semibold text-gray-900 mb-4">Hospital Statistics</h3>
              
              <div className="space-y-4">
                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-2">
                    <Bed className="h-4 w-4 text-gray-500" />
                    <span className="text-sm text-gray-600">Total Beds</span>
                  </div>
                  <span className="font-semibold text-gray-900">{application.numberOfBeds}</span>
                </div>

                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-2">
                    <Activity className="h-4 w-4 text-gray-500" />
                    <span className="text-sm text-gray-600">Facilities</span>
                  </div>
                  <span className="font-semibold text-gray-900">{application.facilities?.length || 0}</span>
                </div>

                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-2">
                    <Stethoscope className="h-4 w-4 text-gray-500" />
                    <span className="text-sm text-gray-600">Specialties</span>
                  </div>
                  <span className="font-semibold text-gray-900">{application.specialities?.length || 0}</span>
                </div>

                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-2">
                    <FileText className="h-4 w-4 text-gray-500" />
                    <span className="text-sm text-gray-600">Documents</span>
                  </div>
                  <span className="font-semibold text-gray-900">{Object.keys(application.documents || {}).length}</span>
                </div>

                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-2">
                    <Camera className="h-4 w-4 text-gray-500" />
                    <span className="text-sm text-gray-600">Facility Photos</span>
                  </div>
                  <span className="font-semibold text-gray-900">{getFacilityPhotos().length}</span>
                </div>
              </div>
            </div>

            {/* Activity Timeline */}
            <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
              <h3 className="text-lg font-semibold text-gray-900 mb-4">Activity Timeline</h3>
              
              <div className="space-y-4">
                <div className="flex items-start space-x-3">
                  <div className="bg-blue-100 p-1 rounded-full">
                    <Clock className="h-3 w-3 text-blue-600" />
                  </div>
                  <div>
                    <p className="text-sm font-medium text-gray-900">Application Submitted</p>
                    <p className="text-xs text-gray-500">{formatDate(application.submittedAt)}</p>
                  </div>
                </div>

                {application.status === 'approved' && (
                  <div className="flex items-start space-x-3">
                    <div className="bg-green-100 p-1 rounded-full">
                      <CheckCircle className="h-3 w-3 text-green-600" />
                    </div>
                    <div>
                      <p className="text-sm font-medium text-gray-900">Application Approved</p>
                      <p className="text-xs text-gray-500">{formatDate(application.approvedAt)}</p>
                    </div>
                  </div>
                )}

                {application.status === 'rejected' && (
                  <div className="flex items-start space-x-3">
                    <div className="bg-red-100 p-1 rounded-full">
                      <XCircle className="h-3 w-3 text-red-600" />
                    </div>
                    <div>
                      <p className="text-sm font-medium text-gray-900">Application Rejected</p>
                      <p className="text-xs text-gray-500">{formatDate(application.rejectedAt)}</p>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Document Viewer Modal */}
      {showDocumentModal && selectedDocument && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-lg max-w-4xl w-full h-5/6 flex flex-col">
            <div className="flex items-center justify-between p-4 border-b border-gray-200">
              <div>
                <h3 className="text-lg font-semibold text-gray-900">Document Viewer</h3>
                <p className="text-sm text-gray-600">{selectedDocument.fileName}</p>
              </div>
              <div className="flex items-center space-x-2">
                <button
                  onClick={() => downloadDocument(selectedDocument)}
                  className="btn-outline"
                >
                  <Download className="h-4 w-4 mr-2" />
                  Download
                </button>
                <button
                  onClick={() => setShowDocumentModal(false)}
                  className="text-gray-400 hover:text-gray-600"
                >
                  <X className="h-6 w-6" />
                </button>
              </div>
            </div>
            
            <div className="flex-1 p-4">
              {selectedDocument.fileName.toLowerCase().endsWith('.pdf') ? (
                <iframe
                  src={selectedDocument.url}
                  className="w-full h-full border border-gray-300 rounded"
                  title="Document Viewer"
                />
              ) : (
                <div className="w-full h-full flex items-center justify-center bg-gray-50 rounded">
                  <img
                    src={selectedDocument.url}
                    alt={selectedDocument.fileName}
                    className="max-w-full max-h-full object-contain"
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Approval Modal */}
      {showApprovalModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-lg max-w-md w-full p-6">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-lg font-semibold text-gray-900">Approve Hospital Application</h3>
              <button
                onClick={() => setShowApprovalModal(false)}
                className="text-gray-400 hover:text-gray-600"
              >
                <X className="h-6 w-6" />
              </button>
            </div>

            <div className="mb-6">
              <div className="bg-green-50 border border-green-200 rounded-lg p-4">
                <div className="flex items-center space-x-3">
                  <CheckCircle className="h-5 w-5 text-green-600" />
                  <div>
                    <h4 className="font-medium text-green-800">Approving Hospital</h4>
                    <p className="text-sm text-green-600">
                      {application.hospitalName} will be granted access to the platform using the credentials they provided during registration.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex justify-end space-x-3">
              <button
                onClick={() => setShowApprovalModal(false)}
                className="btn-outline"
              >
                Cancel
              </button>
              <button
                onClick={handleApproveHospital}
                disabled={actionLoading.approve}
                className="btn-success"
              >
                {actionLoading.approve ? (
                  <>
                    <Loader className="h-4 w-4 mr-2 animate-spin" />
                    Approving...
                  </>
                ) : (
                  <>
                    <CheckCircle className="h-4 w-4 mr-2" />
                    Approve Hospital
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Rejection Modal */}
      {showRejectionModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-lg max-w-md w-full p-6">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-lg font-semibold text-gray-900">Reject Hospital Application</h3>
              <button
                onClick={() => setShowRejectionModal(false)}
                className="text-gray-400 hover:text-gray-600"
              >
                <X className="h-6 w-6" />
              </button>
            </div>

            <div className="mb-6">
              <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-4">
                <div className="flex items-center space-x-3">
                  <XCircle className="h-5 w-5 text-red-600" />
                  <div>
                    <h4 className="font-medium text-red-800">Rejecting Application</h4>
                    <p className="text-sm text-red-600">
                      {application.hospitalName} will be notified about the rejection
                    </p>
                  </div>
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Rejection Reason *
                </label>
                <textarea
                  value={rejectionReason}
                  onChange={(e) => setRejectionReason(e.target.value)}
                  rows="4"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-teal-500"
                  placeholder="Provide detailed reason for rejection..."
                  required
                />
                <p className="text-xs text-gray-500 mt-1">
                  This reason will be communicated to the hospital
                </p>
              </div>
            </div>

            <div className="flex justify-end space-x-3">
              <button
                onClick={() => setShowRejectionModal(false)}
                className="btn-outline"
              >
                Cancel
              </button>
              <button
                onClick={handleRejectHospital}
                disabled={!rejectionReason.trim() || actionLoading.reject}
                className="btn-danger"
              >
                {actionLoading.reject ? (
                  <>
                    <Loader className="h-4 w-4 mr-2 animate-spin" />
                    Rejecting...
                  </>
                ) : (
                  <>
                    <XCircle className="h-4 w-4 mr-2" />
                    Reject Application
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Request Additional Data Modal */}
      {showRequestModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-lg max-w-lg w-full p-6">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-lg font-semibold text-gray-900">Request Additional Documents</h3>
              <button
                onClick={() => setShowRequestModal(false)}
                className="text-gray-400 hover:text-gray-600"
              >
                <X className="h-6 w-6" />
              </button>
            </div>

            <div className="mb-6">
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-4">
                <div className="flex items-center space-x-3">
                  <MessageSquare className="h-5 w-5 text-blue-600" />
                  <div>
                    <h4 className="font-medium text-blue-800">Request from Hospital</h4>
                    <p className="text-sm text-blue-600">
                      {application.hospitalName} will be notified to submit additional documents
                    </p>
                  </div>
                </div>
              </div>

              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Request Message *
                </label>
                <textarea
                  value={requestMessage}
                  onChange={(e) => setRequestMessage(e.target.value)}
                  rows="3"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-teal-500"
                  placeholder="Explain what additional information or documents are needed..."
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Required Documents *
                </label>
                <div className="space-y-2 max-h-40 overflow-y-auto border border-gray-200 rounded-lg p-3">
                  {availableDocuments.map((doc, index) => (
                    <label key={index} className="flex items-center space-x-2">
                      <input
                        type="checkbox"
                        checked={requestDocuments.includes(doc)}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setRequestDocuments([...requestDocuments, doc]);
                          } else {
                            setRequestDocuments(requestDocuments.filter(d => d !== doc));
                          }
                        }}
                        className="rounded border-gray-300 text-teal-600 focus:ring-teal-500"
                      />
                      <span className="text-sm text-gray-700">{doc}</span>
                    </label>
                  ))}
                </div>
                <p className="text-xs text-gray-500 mt-1">
                  Select the documents that need to be submitted
                </p>
              </div>
            </div>

            <div className="flex justify-end space-x-3">
              <button
                onClick={() => setShowRequestModal(false)}
                className="btn-outline"
              >
                Cancel
              </button>
              <button
                onClick={handleRequestAdditionalData}
                disabled={!requestMessage.trim() || requestDocuments.length === 0 || actionLoading.request}
                className="btn-primary"
              >
                {actionLoading.request ? (
                  <>
                    <Loader className="h-4 w-4 mr-2 animate-spin" />
                    Sending Request...
                  </>
                ) : (
                  <>
                    <Send className="h-4 w-4 mr-2" />
                    Send Request
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default HospitalApplicationDetails;